import { ArrowRightOutlined } from "@ant-design/icons"
import { Flex, Typography, theme } from "antd"
import React from "react"

const { Title, Text } = Typography

interface GuideJourneyCardProps {
  icon: React.ReactNode
  title: string
  description: string
  duration: string
  onAction: () => void
}

/** A larger, click-anywhere version of what used to be a plain text link —
 * purely presentational, `onAction` is the exact same handler the caller
 * already had (startTour / navigate), just invoked from a bigger surface. */
export const GuideJourneyCard = ({
  icon,
  title,
  description,
  duration,
  onAction
}: GuideJourneyCardProps) => {
  const { token } = theme.useToken()

  return (
    <button
      type="button"
      onClick={onAction}
      className="flex-1 cursor-pointer rounded-xl border bg-transparent px-6 py-6 text-left transition-colors hover:shadow-sm"
      style={{ borderColor: token.colorBorderSecondary, background: token.colorBgContainer }}
    >
      <Flex align="center" gap={16}>
        <Flex
          align="center"
          justify="center"
          className="size-12 shrink-0 rounded-full"
          style={{ background: token.colorPrimaryBg, color: token.colorPrimary }}
        >
          {icon}
        </Flex>
        <Flex vertical gap={2} className="min-w-0 flex-1">
          <Title level={5} className="!mb-0">
            {title}
          </Title>
          <Text type="secondary" className="text-sm">
            {description}
          </Text>
          <Text type="secondary" className="text-xs">
            {duration}
          </Text>
        </Flex>
        <ArrowRightOutlined style={{ color: token.colorPrimary }} />
      </Flex>
    </button>
  )
}
